export const mapLangToCS: Record<string, string> = {
	aar: 'afarština',
	abk: 'abcházština',
	ave: 'avestánština',
	afr: 'afrikánština',
	aka: 'akanština',
	amh: 'amharština',
	arg: 'aragonština',
	ara: 'arabština',
	asm: 'ásámština',
	ava: 'avarština',
	aym: 'ajmarština',
	aze: 'ázerbájdžánština',
	bak: 'baškirština',
	bel: 'běloruština',
	bul: 'bulharština',
	bih: 'bihárština',
	bis: 'bislamština',
	bam: 'bambarština',
	ben: 'bengálština',
	tib: 'tibetština',
	bod: 'tibetština',
	bre: 'bretonština',
	bos: 'bosenština',
	cat: 'katalánština',
	che: 'čečenština',
	cha: 'chamorro',
	cos: 'korsičtina',
	cre: 'kríjština',
	cze: 'čeština',
	ces: 'čeština',
	chu: 'staroslověnština',
	chv: 'čuvaština',
	wel: 'velština',
	cym: 'velština',
	dan: 'dánština',
	ger: 'němčina',
	deu: 'němčina',
	div: 'divehi',
	dzo: 'dzongkha',
	ewe: 'eveština',
	gre: 'řečtina',
	ell: 'řečtina',
	eng: 'angličtina',
	epo: 'esperanto',
	spa: 'španělština',
	est: 'estonština',
	baq: 'baskičtina',
	eus: 'baskičtina',
	per: 'perština',
	fas: 'perština',
	ful: 'fulbština',
	fin: 'finština',
	fij: 'fidžijština',
	fao: 'faerština',
	fre: 'francouzština',
	fra: 'francouzština',
	fry: 'západofríština',
	gle: 'irština',
	gla: 'skotská gaelština',
	glg: 'galicijština',
	grn: 'guaraní',
	guj: 'gudžarátština',
	glv: 'manština',
	hau: 'hauština',
	heb: 'hebrejština',
	hin: 'hindština',
	hmo: 'hiri motu',
	scr: 'chorvatština',
	hrv: 'chorvatština',
	hat: 'haitština',
	hun: 'maďarština',
	arm: 'arménština',
	hye: 'arménština',
	her: 'hererština',
	ina: 'interlingua',
	ind: 'indonéština',
	ile: 'interlingue',
	ibo: 'igbo',
	iii: 'yi',
	ipk: 'inupiaq',
	ido: 'ido',
	ice: 'islandština',
	isl: 'islandština',
	ita: 'italština',
	iku: 'inuitština',
	jpn: 'japonština',
	jav: 'javánština',
	geo: 'gruzínština',
	kat: 'gruzínština',
	kon: 'konžština',
	kik: 'kikujština',
	kua: 'kuanyama',
	kaz: 'kazaština',
	kal: 'grónština',
	khm: 'khmerština',
	kan: 'kannadština',
	kor: 'korejština',
	kau: 'kanurijština',
	kas: 'kašmírština',
	kur: 'kurdština',
	kom: 'komijština',
	cor: 'kornština',
	kir: 'kyrgyzština',
	lat: 'latina',
	ltz: 'lucemburština',
	lug: 'gandština',
	lim: 'limburština',
	lin: 'ngalština',
	lao: 'laoština',
	lit: 'litevština',
	lub: 'lubština',
	lav: 'lotyština',
	mlg: 'malgaština',
	mah: 'maršálština',
	mao: 'maorština',
	mri: 'maorština',
	mac: 'makedonština',
	mkd: 'makedonština',
	mal: 'malajámština',
	mon: 'mongolština',
	mol: 'moldavština',
	mar: 'maráthština',
	may: 'malajština',
	msa: 'malajština',
	mlt: 'maltština',
	bur: 'barmština',
	mya: 'barmština',
	nau: 'nauruština',
	nob: 'bokmål',
	nde: 'severní ndebelština',
	nep: 'nepálština',
	ndo: 'ndonga',
	dut: 'nizozemština',
	nld: 'nizozemština',
	nno: 'nynorsk',
	nor: 'norština',
	nbl: 'jižní ndebelština',
	nav: 'navažština',
	nya: 'čičevština',
	oci: 'okcitánština',
	oji: 'odžibvejština',
	orm: 'oromština',
	ori: 'urijština',
	oss: 'osetština',
	pan: 'paňdžábština',
	pli: 'páli',
	pol: 'polština',
	pus: 'paštština',
	por: 'portugalština',
	que: 'kečuánština',
	roh: 'rétorománština',
	run: 'kirundština',
	rum: 'rumunština',
	ron: 'rumunština',
	rus: 'ruština',
	kin: 'rwandština',
	san: 'sanskrt',
	srd: 'sardština',
	snd: 'sindhština',
	sme: 'severní sámština',
	sag: 'sangština',
	sin: 'sinhálština',
	slo: 'slovenština',
	slk: 'slovenština',
	slv: 'slovinština',
	smo: 'samojština',
	sna: 'šonština',
	som: 'somálština',
	alb: 'albánština',
	sqi: 'albánština',
	scc: 'srbština',
	srp: 'srbština',
	ssw: 'svazijština',
	sot: 'sotština',
	sun: 'sundština',
	swe: 'švédština',
	swa: 'svahilština',
	tam: 'tamilština',
	tel: 'telugština',
	tgk: 'tádžičtina',
	tha: 'thajština',
	tir: 'tigriňňa',
	tuk: 'turkmenština',
	tgl: 'tagalština',
	tsn: 'čwanština',
	ton: 'tonžština',
	tur: 'turečtina',
	tso: 'tsonga',
	tat: 'tatarština',
	twi: 'ťwiština',
	tah: 'tahitština',
	uig: 'ujgurština',
	ukr: 'ukrajinština',
	urd: 'urdština',
	uzb: 'uzbečtina',
	ven: 'luvendština',
	vie: 'vietnamština',
	vol: 'volapük',
	wln: 'valonština',
	wol: 'volofština',
	xho: 'xhoština',
	yid: 'jidiš',
	yor: 'jorubština',
	zha: 'čuangština',
	chi: 'čínština',
	zho: 'čínština',
	zul: 'zulština',
	grc: 'starořečtina',
	zxx: 'žádný lingvistický obsah',
	tai: 'thajské jazyky',
	und: 'neurčený jazyk',
	sla: 'slovanské jazyky',
	mul: 'směs více jazyků',
	inc: 'indické jazyky',
	akk: 'akkadština',
	arc: 'aramejština',
	rom: 'romština',
	wen: 'lužickosrbské jazyky',
	egy: 'egyptština',
	sux: 'sumerština',
	frm: 'střední francouzština',
	syr: 'syrština',
	fro: 'starofrancouzština',
	cop: 'koptština',
	mis: 'jazyky bez kódu',
	ine: 'indoevropské jazyky',
	dum: 'střední nizozemština',
	hit: 'chetitština',
	ira: 'íránské jazyky',
	haw: 'havajština',
	unknown: 'neznámy',
};
